import { LoadingSpinner } from "../../../../Loader/styles"

export const PlaceHolder = () => {
  return (
    <div style={{ height: 380, width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <LoadingSpinner />
    </div>
  )
}